
import Vue, { PropType } from "vue";
import { DialogI } from "@/types/dialog";
import BaseDialog from "@/components/dialog/BaseDialog.vue";
import Btn from "@/components/v2/base/Btn.vue";
import RepetitionWordsInfo from "@/components/words/repetition/RepetitionWordsInfo.vue";

export default Vue.extend({
  name: "RepetitionWordsInfoDialog",
  components: {
    BaseDialog,
    Btn,
    RepetitionWordsInfo,
  },
  props: {
    dialog: {
      type: Object as PropType<DialogI>,
      required: true,
    },
  },
});
